import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .bp-text-area {
    text-align: center;
    margin-top: 172px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 80%;
    h1 {
      line-height: 1.5;
      font-size: 24px;
    }
    p {
      margin-top: 20px;
      line-height: 1.5;
      font-size: 16px;
    }
    .bp-center-button {
      margin-top: 100px;
      width: 194px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 24px;
      background-color: #252833;
      cursor: pointer;
      p {
        margin: 0;
        line-height: 1.5;
        font-size: 16px;
      }
    }
  }

  .bp-card-content-extern {
    margin: 120px 0px 0px;
    .bp-card-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: calc(100% + 32px);
      margin: -16px;
      flex-wrap: wrap;
      box-sizing: border-box;
    }
  }

  .img-container {
    width: 100%;
    padding-top: 30px;
    display: flex;
    justify-content: center;
    img {
      margin: 0 auto;
      width: 90%;
      max-width: 450px;
    }
  }
  @media screen and (max-width: 950px) {
    .bp-card-content {
      grid-template-columns: 1fr !important;
    }
  }
`;
